function ChevronLeft({ style }) {
  const { fill = '#150828', width = 24, height = 24 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.667"
        d="M14.666 18.667 9.44 12.315a.46.46 0 0 1-.08-.144.528.528 0 0 1 .08-.484l5.226-6.353"
      />
    </svg>
  );
}

export default ChevronLeft;
